import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import Homepage from "../pages/Homepage";
import Dashboard from "../pages/Dashboard";
import UserManagement from "../pages/UserManagement";
import MainLayout from "../components/MainLayout";
import Categories from "../pages/Categories";
import AdminManagement from "../pages/AdminManagement";
import Settings from "../pages/Settings";
import Sliders from "../pages/SlidersManagement";
import Promotions from "../pages/Promotions";
import Notifications from "../pages/Notifications";
import Transactions from "../pages/Transactions";
import Reports from "../pages/Reports";

// Data
import DataPlan from "../pages/Products/Data/Plans";
import DataProviders from "../pages/Products/Data/Providers";
import DataCategories from "../pages/Products/Data/Categories";

// Airtime
import AirtimePlan from "../pages/Products/Airtime/Plans";
import AirtimeProviders from "../pages/Products/Airtime/Providers";
import AirtimeCategories from "../pages/Products/Airtime/Categories";

// Cable
import CablePlan from "../pages/Products/Cable/Plans";
import CableProviders from "../pages/Products/Cable/Providers";
import CableCategories from "../pages/Products/Cable/Categories";

// Electricity
import ElectricPlan from "../pages/Products/Electric/Plans";
import ElectricProviders from "../pages/Products/Electric/Providers";
import ElectricCategories from "../pages/Products/Electric/Categories";

// Gift Cards
import GiftcardPlan from "../pages/Products/Giftcards/Plans";
import GiftcardProviders from "../pages/Products/Giftcards/Providers";
import GiftcardCategories from "../pages/Products/Giftcards/Categories";

// DG Coins
import DGCoinPlan from "../pages/Products/DGCoins/Plans";
import DGCoinProviders from "../pages/Products/DGCoins/Providers";
import DGCoinCategories from "../pages/Products/DGCoins/Categories";

// Game Cards
import GamecardPlan from "../pages/Products/Gamecards/Plans";
import GamecardProviders from "../pages/Products/Gamecards/Providers";
import GamecardCategories from "../pages/Products/Gamecards/Categories";

// Top Up Plan
import TopupcardPlan from "../pages/Products/Topupcards/Plans";
import TopupcardProviders from "../pages/Products/Topupcards/Provider";
import TopupardCategories from "../pages/Products/Topupcards/Categories";
import { useAppSelector } from "../hooks/hooks";
import CurrenciesManagementPage from "../pages/CurrenciesManagement";
import CountriesManagementPage from "../pages/CountriesManagement";
import Support from "../pages/Support";

const AppRouter: React.FC = () => {
  const { token, user } = useAppSelector((state) => state.auth);
  const isAuthenticated = Boolean(token || user);

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Homepage />
            )
          }
        />

        {/* Protected routes wrapped with layout */}
        <Route
          path="/"
          element={
            isAuthenticated ? <MainLayout /> : <Navigate to="/" replace />
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="currencies" element={<CurrenciesManagementPage />} />
          <Route path="countries" element={<CountriesManagementPage />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="categories" element={<Categories />} />
          <Route path="admin-management" element={<AdminManagement />} />
          <Route path="settings" element={<Settings />} />
          <Route path="reports" element={<Reports />} />
          <Route path="sliders" element={<Sliders />} />
          <Route path="support" element={<Support />} />
          {/* Data Product Submenus */}
          <Route path="/products/data/plans" element={<DataPlan />} />
          <Route path="/products/data/providers" element={<DataProviders />} />
          <Route
            path="/products/data/categories"
            element={<DataCategories />}
          />
          <Route path="/products/airtime/plans" element={<AirtimePlan />} />
          <Route
            path="/products/airtime/providers"
            element={<AirtimeProviders />}
          />
          <Route
            path="/products/airtime/categories"
            element={<AirtimeCategories />}
          />
          {/* Cable Product Submenus */}
          <Route path="/products/cable/plans" element={<CablePlan />} />
          <Route
            path="/products/cable/providers"
            element={<CableProviders />}
          />
          <Route
            path="/products/cable/categories"
            element={<CableCategories />}
          />

          {/* Electricity Product Submenus */}
          <Route path="/products/electric/plans" element={<ElectricPlan />} />
          <Route
            path="/products/electric/providers"
            element={<ElectricProviders />}
          />
          <Route
            path="/products/electric/categories"
            element={<ElectricCategories />}
          />

          {/* Gift Cards Product Submenus */}
          <Route path="/products/giftcards/plans" element={<GiftcardPlan />} />
          <Route
            path="/products/giftcards/providers"
            element={<GiftcardProviders />}
          />
          <Route
            path="/products/giftcards/categories"
            element={<GiftcardCategories />}
          />

          {/* DG Coin Product Submenus */}
          <Route path="/products/dgcoins/plans" element={<DGCoinPlan />} />
          <Route
            path="/products/dgcoins/providers"
            element={<DGCoinProviders />}
          />
          <Route
            path="/products/dgcoins/categories"
            element={<DGCoinCategories />}
          />

          {/* Game Cards Product Submenus */}
          <Route path="/products/gamecards/plans" element={<GamecardPlan />} />
          <Route
            path="/products/gamecards/providers"
            element={<GamecardProviders />}
          />
          <Route
            path="/products/gamecards/categories"
            element={<GamecardCategories />}
          />
          {/* Top Up Cards Product Submenus */}
          <Route path="/products/topupcard/plans" element={<TopupcardPlan />} />
          <Route
            path="/products/topupcards/providers"
            element={<TopupcardProviders />}
          />
          <Route
            path="/products/topupcards/categories"
            element={<TopupardCategories />}
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
